import React, { useEffect } from 'react';//{useState}
import './App.scss';
import { Header } from './components/Header';
import { BrowserRouter as Router, Route } from "react-router-dom";
import CompanyDetails from './containers/CompanyDetails';
import AccountDetails from './containers/AccountDetails';
import NSPersonDetails from './containers/NSPersonDetails';
import Example from './containers/Example';
import FinanceDetails from './containers/FinanceDetails.jsx';
import DeclarationsDetails from './containers/DeclarationsDetails';
import Preview from './containers/Preview';
import InvalidOTP from './invalidcontainers/InvalidOTP';
import StatusComplete from './containers/StatusComplete';
import StatusProgress from './containers/StatusProgress';
import ResumeApplication from './containers/ResumeApplication';
import StatusDetails from './nscontainers/StatusDetails';
import InvalidEntity from './invalidcontainers/InvalidEntity';
import ReviewOffer from './nscontainers/ReviewOffer';
import LetterOfOffer from './nscontainers/LetterOfOffer';
import MyInfoLanding from './containers/MyInfoLanding';
import SubmitDetails from './nscontainers/SubmitDetails';
import BoardMeetingDate from './nscontainers/BoardMeetingDate';
import Disbursement from './nscontainers/Disbursement';
import ExpiredLoanOffer from './invalidcontainers/ExpiredLoanOffer';
import Welcome from './containers/Welcome';
import SessionExpired from './invalidcontainers/SessionExpired';
import InvalidDirectors from './invalidcontainers/InvalidDirectors';
import PreKnockoutFailed from './invalidcontainers/PreKnockoutFailed'; 
import InvalidApplication from './invalidcontainers/InvalidApplication';
import AppCancelled from './nscontainers/AppCancelled';
import MainFinanceDetails from './hybridcontainers/MainFinanceDetails';
import PropertyDetails from './hybridcontainers/PropertyDetails';
import SubAPLanding from './hybridcontainers/SubAPLanding.jsx';
import HStatusInfoDetails from './hybridcontainers/HStatusInfoDetails.jsx'
import HSubmitDetails from './hybridcontainers/HSubmitDetails.jsx';
import HStatusReject from './hybridcontainers/HStatusReject.jsx';
import UploadDetails from './hybridcontainers/UploadDetails.jsx';
import PropertyDetailsAIP from './hybridcontainers/PropertyDetailsAIP.jsx';
import SPersonDetails from './containers/SPersonDetails.jsx';
import AIPStatusInfoDetails from './hybridcontainers/AIPStatusInfoDetails.jsx';
import AIPStatusApproved from './hybridcontainers/AIPStatusApproved.jsx';
import AIPStatusReject from './hybridcontainers/AIPStatusReject.jsx';

function App() {

  useEffect(() => {
    console.log('@App useEffect');
  }, []);

  return (
    <Router>
      <div className="content">
        <Header projectName={'rsmedigitalfinancing'} />
        <Route exact path="/rsmedigitalfinancing" component={MainFinanceDetails} />
        <Route path= "/rsmedigitalfinancing/FinanceDetails" component={MainFinanceDetails} />
        {/* <Route exact path="/rsmedigitalfinancing" component={FinanceDetails} /> */}
        <Route path = "/rsmedigitalfinancing/MyInfoLanding" component={MyInfoLanding} />
        {/* <Route path = "/rsmedigitalfinancing/FinanceDetails" component={FinanceDetails}  /> */}
        <Route path = "/rsmedigitalfinancing/editdetails" component={MainFinanceDetails}  />
        <Route path = "/rsmedigitalfinancing/CompanyDetails" component={CompanyDetails}  />
        <Route path = "/rsmedigitalfinancing/AccountDetails" component={AccountDetails}  />
        <Route path = "/rsmedigitalfinancing/DeclarationsDetails" component={DeclarationsDetails}  />
        <Route path = "/rsmedigitalfinancing/Preview" component={Preview}  />
        <Route path = "/rsmedigitalfinancing/Example" component={Example}  />
        <Route path = "/rsmedigitalfinancing/InvalidOTP" component={InvalidOTP} />
 		    <Route path = "/rsmedigitalfinancing/StatusComplete" component={StatusComplete} />
        <Route path = "/rsmedigitalfinancing/StatusProgress" component={StatusProgress} />
        <Route path = "/rsmedigitalfinancing/ResumeApplication" component={ResumeApplication} />
        <Route path = "/rsmedigitalfinancing/StatusDetails" component={StatusDetails} />
        <Route path = "/rsmedigitalfinancing/InvalidEntity" component={InvalidEntity} />
        <Route path = "/rsmedigitalfinancing/InvalidDirectors" component={InvalidDirectors} />
        <Route path = "/rsmedigitalfinancing/SubmitDetails" component={SubmitDetails} />
        <Route path = "/rsmedigitalfinancing/NSPersonDetails" component={NSPersonDetails} />
        <Route path="/rsmedigitalfinancing/ReviewOffer" component={ReviewOffer} />
        <Route path="/rsmedigitalfinancing/LetterOfOffer" component={LetterOfOffer} />
        <Route path="/rsmedigitalfinancing/BoardMeetingDate" component={BoardMeetingDate} />
        <Route path="/rsmedigitalfinancing/Disbursement" component={Disbursement} />
        <Route path="/rsmedigitalfinancing/ExpiredLoanOffer" component={ExpiredLoanOffer} />
        <Route path="/rsmedigitalfinancing/Welcome" component={Welcome} />
        <Route path="/rsmedigitalfinancing/SessionExpired" component={SessionExpired} />
        <Route path="/rsmedigitalfinancing/PreKnockoutFailed" component={PreKnockoutFailed} />
        <Route path="/rsmedigitalfinancing/InvalidApplication" component={InvalidApplication} />
        <Route path="/rsmedigitalfinancing/AppCancelled" component={AppCancelled} />
        <Route path= "/rsmedigitalfinancing/PropertyDetails" component={PropertyDetails} />
        <Route path= "/rsmedigitalfinancing/APropertyDetails" component={PropertyDetailsAIP} />
        <Route path= "/rsmedigitalfinancing/SubAPLanding" component={SubAPLanding} />
        <Route path= "/rsmedigitalfinancing/HStatusInfoDetails" component={HStatusInfoDetails} />
        <Route path= "/rsmedigitalfinancing/HStatusReject" component={HStatusReject} />
        <Route path= "/rsmedigitalfinancing/HSubmitDetails" component={HSubmitDetails} />
        <Route path= "/rsmedigitalfinancing/UploadDetails" component={UploadDetails} />
        <Route path= "/rsmedigitalfinancing/SPersonDetails" component={SPersonDetails} />
        <Route path= "/rsmedigitalfinancing/AStatusInfoDetails" component={AIPStatusInfoDetails} />
        <Route path= "/rsmedigitalfinancing/AStatusApprovalDetails" component={AIPStatusApproved} />
        <Route path= "/rsmedigitalfinancing/AStatusReject" component={AIPStatusReject} />
      </div>
    </Router>
  );
}

export default App;
